import { render, staticRenderFns } from "./OverlayAccept.vue?vue&type=template&id=cc3ccdfc&scoped=true"
import script from "./OverlayAccept.vue?vue&type=script&lang=js"
export * from "./OverlayAccept.vue?vue&type=script&lang=js"
import style0 from "./OverlayAccept.vue?vue&type=style&index=0&id=cc3ccdfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3ccdfc",
  null
  
)

export default component.exports